import { render } from "./EventImage.vue?vue&type=template&id=9d8e9388"
import script from "./EventImage.vue?vue&type=script&lang=js"
export * from "./EventImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__